import React, { useState, useEffect, useLayoutEffect, useRef } from "react";
import {
  Card, CircularProgress, Dialog, Button, 
  TextField, Grid, 
} from '@mui/material';
import Box from '@mui/material/Box';
import EssayViewQuestion from './essay/essay-view-question';
import { AppHelper } from '../AppHelper';
import CloseIcon from '@mui/icons-material/Close';

export default function PopDraftPreview({
  onClose, open, essayId
}) {
var oUser = AppHelper.userCacheGet();
const [bodyText, setBodyText] = useState('');
const [title, setTitle] = useState('');
const [questionList, setQuestionList] = useState([]);
const [question, setQuestion] = React.useState({});
const [originalImage, setOriginalImage] = useState('');

  useEffect(() => {
    if (!open) return;
    
    if (!essayId) {
      setQuestion({}); 
      setOriginalImage('');
        setTitle("");
        setBodyText("");
      return;
    }
    const loadEssay = async () => {
      const _res = await AppHelper.apiPost('api/essay/detail', { token: oUser.token, essayId: essayId });
      if (_res && _res.status) {
        setTitle(_res.data.topic);
        setBodyText(_res.text.replace(/\n/g, "<br/>").replace(/Page Break/g, "<div style='color:white;background-color:blue;display:inline-block'>Page Break</div>"));
        setOriginalImage(_res.imgs);
        if (_res.data.questionId.length > 0) {
          setQuestion(_res.question);
          return;
        } else {
          setQuestion(0);
        }
      }
    }
    
    loadEssay();
  }, [essayId, open]);

  const handleClose = () => { 
    setQuestion({}); 
    setTitle('');
    setBodyText('');
    setOriginalImage('');
    onClose();
  };

  return (
    <>
      <Dialog onClose={handleClose} open={open} fullWidth
        maxWidth={false}
        sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: 'none' }}}
      >
        <Button style={{ position: 'absolute',
                          top: 0,
                          right: 0,
                          margin: '10px',
                          color:"rgba(19,130,117,1)"  
                        }}
                  onClick={handleClose}
                  justifyItem="right">
            <CloseIcon/>
        </Button>
        {((originalImage.length > 0)) && (
          <div style={{ marginTop: '1rem', marginLeft: '1rem', marginBottom: '-2rem', fontWeight: 'bold' }}>
            Transcribed Essay 
          </div>
        )}
        <Grid item xs={12} sm={12} sx={{marginLeft: '1rem', marginRight: '1rem', marginTop: '2rem', }}> 
          {(question.questionId == null && question != 0) &&
          <div style={{ margin: '1rem' }}>
            <CircularProgress />
          </div>
          }
          {question.questionId != null &&
            <Card variant="outlined" sx={{padding:1.5, marginRight:0, borderRadius:'20px', marginTop:'1rem', fontSize:'18px'}}>
              <div style={{marginBottom:'8px'}}>Selected Question</div>
              <div> { <EssayViewQuestion question={question} />} </div>
            </Card>
          } 
        </Grid>
        <Grid item xs={12} sm={12}
        sx={{
          backgroundColor: '#fff', borderRadius: '20px', border: '1px solid rgba(0, 0, 0, 0.12)', 
          marginLeft: '1rem', marginRight: '1rem', marginTop: '1rem', marginBottom: '1rem', 
          overflowY:'hidden', 
        }}>
          <Grid item xs={12}>
            <Box sx={{ fontWeight: 'bold', textAlign: 'center', paddingLeft: '10px', paddingRight: '10px' }}>
              <TextField
                value={title}
                label="" variant="standard" fullWidth
                sx={{ "& fieldset": { border: 'none' },  }}
                inputProps={{
                    readOnly: true, 
                    style: {
                      fontFamily: "Playpen Sans", fontSize: '2rem',
                      textAlign: 'center', //disableUnderline: true
                    }
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12}>
            <Box
              sx={{
                fontSize: '1.3rem', lineHeight: '35px', fontFamily: "'Playpen Sans', cursive", 
                border: '0 solid #efefef', borderRadius: '6px', padding: '5px', marginLeft: '5px', marginRight: '5px',
              }}>
                <div className="divBody"
                  data-text={bodyText}
                  contentEditable="false"
                  dangerouslySetInnerHTML={{ __html: bodyText }}
                  style={{
                    fontSize: '1.3rem', fontFamily: "'Playpen Sans', cursive", lineHeight: '35px',
                    background: 'linear-gradient(to bottom, white 34px, #00b0d7 1px)', backgroundSize: '100% 35px',
                    backgroundAttachment: 'local', height: question.questionId == null ? '50vh' : '45vh',
                    direction: 'ltr', // Ensure left-to-right text direction
                    width: '100%', textAlign: 'left', padding: '0', border: 'none', outline: 'none', overflow: 'auto',
                  }}
                >
                </div>
            </Box>
          </Grid>
        </Grid>
      </Dialog>
    </>
  );
}
